import Controller from "./tickets.controller";
import template from "./tickets.html";

const tickets = {
  template,
  controller: Controller,
};

export default tickets;



// WEBPACK FOOTER //
// ./src/pages/tickets/tickets.component.js